import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Leaf } from "lucide-react";
import GrassBorder from "@/components/public/GrassBorder";
import { fileUrl } from "@/lib/api";
import { SITE_VERSION, LAST_UPDATE } from "@/version";

const LOGO = "/logo-acanthe-blanc.png";
const BESSON_LOGO = fileUrl("acanthe-jardins/uploads/cf3b55de-3d8c-4b42-99c6-d0786ebd4c10.png");

export default function Footer() {
  return (
    <footer className="relative bg-forest text-cream/80" data-testid="site-footer">
      <GrassBorder className="absolute left-0 -top-[45px]" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={LOGO} alt="Acanthe Jardins" className="h-14 w-auto mb-5" />
          <p className="text-sm leading-relaxed text-cream/60">
            Vos experts en aménagement extérieur dans les Bouches-du-Rhône, le Var et le Vaucluse depuis plus de 14 ans.
          </p>
        </div>
        <div>
          <h4 className="text-cream font-semibold mb-4 text-sm uppercase tracking-wider">Prestations</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/prestations" className="hover:text-terracotta transition-colors">Étude & Diagnostics</Link></li>
            <li><Link to="/prestations" className="hover:text-terracotta transition-colors">Conception & Plans</Link></li>
            <li><Link to="/prestations" className="hover:text-terracotta transition-colors">Création d'espaces verts</Link></li>
            <li><Link to="/prestations" className="hover:text-terracotta transition-colors">Entretien</Link></li>
            <li><Link to="/prestations" className="hover:text-terracotta transition-colors">Terrassement</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-cream font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/realisations" className="hover:text-terracotta transition-colors">Nos réalisations</Link></li>
            <li><Link to="/entreprise" className="hover:text-terracotta transition-colors">L'entreprise & matériel</Link></li>
            <li><Link to="/conseils" className="hover:text-terracotta transition-colors">Conseils & FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-terracotta transition-colors">Demande de devis</Link></li>
            <li><Link to="/admin/login" className="hover:text-terracotta transition-colors">Espace pro</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-cream font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin size={18} className="text-terracotta shrink-0" /> 665 Avenue du Raumartin, 13730 Saint-Victoret</li>
            <li className="flex gap-3"><Phone size={18} className="text-terracotta shrink-0" /> <span><a href="tel:0442690213" className="hover:text-terracotta">04 42 69 02 13</a> · <a href="tel:0634586333" className="hover:text-terracotta">06 34 58 63 33</a></span></li>
            <li className="flex gap-3"><Mail size={18} className="text-terracotta shrink-0" /> <a href="mailto:contact@acanthejardins.fr" className="hover:text-terracotta">contact@acanthejardins.fr</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-cream/50">
          <p className="flex items-center gap-2"><Leaf size={14} className="text-terracotta" /> © {new Date().getFullYear()} Acanthe Jardins — Tous droits réservés</p>
          <p className="text-cream/40" data-testid="footer-version">Version {SITE_VERSION} · Dernière mise à jour : {LAST_UPDATE}</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="hover:text-terracotta transition-colors" data-testid="footer-mentions">Mentions légales</Link>
            <span className="opacity-40">·</span>
            <Link to="/politique-de-confidentialite" className="hover:text-terracotta transition-colors" data-testid="footer-confidentialite">Politique de confidentialité</Link>
          </div>
          <a href="https://besson-solutions.fr" target="_blank" rel="noopener noreferrer" data-testid="footer-besson"
            className="flex items-center gap-2 text-cream/40 hover:text-cream/80 transition-colors">
            <span>Réalisé par</span>
            <img src={BESSON_LOGO} alt="Besson Solutions" className="h-7 w-auto object-contain" />
          </a>
        </div>
      </div>
    </footer>
  );
}
